import React, { useEffect, useState } from "react";
import { useAuth } from "../../auth/AuthContext";
import { PageState } from "../../components/PageState";

type TaskConfig = {
  id: number;
  ativo: boolean;
  avisarAoAtribuir: boolean;
  avisarAntesDias: number;
  avisarNoDeadline: boolean;
  avisarVencidaDiario: boolean;
  horaEnvio: number;
};

export const TasksConfigPage: React.FC = () => {
  const { client } = useAuth();
  const [config, setConfig] = useState<TaskConfig | null>(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);

  const loadConfig = async () => {
    setLoading(true);
    setError(null);
    const response = await client.get("/tasks/config");
    if (!response.ok) {
      setError("Falha ao carregar configuracoes.");
      setLoading(false);
      return;
    }
    const payload = (await response.json()) as { data: TaskConfig };
    setConfig(payload.data);
    setLoading(false);
  };

  useEffect(() => {
    void loadConfig();
  }, []);

  const handleSave = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!config) return;
    setSaving(true);
    setMessage(null);
    setError(null);
    const response = await client.put("/tasks/config", config);
    if (!response.ok) {
      setError("Falha ao salvar configuracoes.");
      setSaving(false);
      return;
    }
    setMessage("Configuracoes salvas.");
    setSaving(false);
  };

  return (
    <div className="container py-4">
      <h1 className="mb-3">Configuracoes de Tarefas</h1>
      <PageState loading={loading} error={error}>
        {config && (
          <form onSubmit={handleSave} className="card shadow-sm">
            <div className="card-body">
              {message && <div className="alert alert-success">{message}</div>}
              <div className="form-check form-switch mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={config.ativo}
                  onChange={(event) =>
                    setConfig((prev) =>
                      prev ? { ...prev, ativo: event.target.checked } : prev
                    )
                  }
                  id="ativo"
                />
                <label className="form-check-label" htmlFor="ativo">
                  Alertas ativos
                </label>
              </div>
              <div className="form-check form-switch mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={config.avisarAoAtribuir}
                  onChange={(event) =>
                    setConfig((prev) =>
                      prev ? { ...prev, avisarAoAtribuir: event.target.checked } : prev
                    )
                  }
                  id="avisarAoAtribuir"
                />
                <label className="form-check-label" htmlFor="avisarAoAtribuir">
                  Avisar ao atribuir
                </label>
              </div>
              <div className="mb-3">
                <label className="form-label">Avisar antes (dias)</label>
                <input
                  className="form-control"
                  type="number"
                  min={0}
                  value={config.avisarAntesDias}
                  onChange={(event) =>
                    setConfig((prev) =>
                      prev
                        ? { ...prev, avisarAntesDias: Number(event.target.value) }
                        : prev
                    )
                  }
                />
              </div>
              <div className="form-check form-switch mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={config.avisarNoDeadline}
                  onChange={(event) =>
                    setConfig((prev) =>
                      prev ? { ...prev, avisarNoDeadline: event.target.checked } : prev
                    )
                  }
                  id="avisarNoDeadline"
                />
                <label className="form-check-label" htmlFor="avisarNoDeadline">
                  Avisar no dia do deadline
                </label>
              </div>
              <div className="form-check form-switch mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={config.avisarVencidaDiario}
                  onChange={(event) =>
                    setConfig((prev) =>
                      prev
                        ? { ...prev, avisarVencidaDiario: event.target.checked }
                        : prev
                    )
                  }
                  id="avisarVencidaDiario"
                />
                <label className="form-check-label" htmlFor="avisarVencidaDiario">
                  Avisar vencidas diariamente
                </label>
              </div>
              <div className="mb-3">
                <label className="form-label">Hora de envio (0-23)</label>
                <input
                  className="form-control"
                  type="number"
                  min={0}
                  max={23}
                  value={config.horaEnvio}
                  onChange={(event) =>
                    setConfig((prev) =>
                      prev ? { ...prev, horaEnvio: Number(event.target.value) } : prev
                    )
                  }
                />
              </div>
              <button className="btn btn-primary" type="submit" disabled={saving}>
                {saving ? "Salvando..." : "Salvar"}
              </button>
            </div>
          </form>
        )}
      </PageState>
    </div>
  );
};
